import {Routes, RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AuthGuard} from "./guards/auth.guard";
import {HomeComponent} from './views/home/home.component';
import {LoginComponent} from "./views/auth/login/login.component";
import {RegisterComponent} from "./views/auth/register/register.component";
import {DashboardComponent} from "./views/dashboard/dashboard.component";
import {EditArtworkComponent} from "./parts/editor/edit-artwork/edit-artwork.component";
import {EditRouteComponent} from "./parts/editor/edit-route/edit-route.component";
import {EditCategoryComponent} from "./parts/editor/edit-category/edit-category.component";
import {EditStructureComponent} from "./parts/editor/edit-structure/edit-structure.component";
import {EditGroupComponent} from "./parts/editor/edit-group/edit-group.component";
import {QrGeneratorComponent} from "./parts/qr-generator/qr-generator.component";
import {RecoveryComponent} from "./views/auth/recovery/recovery.component";

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'login',
    component: LoginComponent,
  }, {
    path: 'register',
    component: RegisterComponent,
  }, {
    path: 'recovery',
    component: RecoveryComponent,
  }, {
    path: 'projects/:project_id/databases/:database_id',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [{
      path: 'artworks/:artwork_id',
      component: EditArtworkComponent
    }, {
      path: 'routes/:route_id',
      component: EditRouteComponent
    }, {
      path: 'structure',
      component: EditStructureComponent
    }, {
      path: 'categories/:category_id',
      component: EditCategoryComponent
    }, {
      path: 'groups/:group_id',
      component: EditGroupComponent
    }, {
      path: 'qr/generate',
      component: QrGeneratorComponent
    },
]
  }, {
    path: '**',
    component: HomeComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
